import axios from "axios";
import React, { useEffect, useState } from "react";
import { GET_AUDIT_NEW_FARMERS } from "../../constants";
import {
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import LongTextComponent from "../Leads Page/LongTextComponent";
import moment from "moment";
import CallIcon from "@mui/icons-material/Call";
import { useNavigate } from "react-router-dom";

function NewOpenLeadList({ setOpenCount, setClosedCount }) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [row, setRow] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  const fetchAuditList = async () => {
    try {
      const response = await axios.get(
        `${GET_AUDIT_NEW_FARMERS}?agentId=${empDetails.EmployeeId}&page=${
          page + 1
        }&limit=${rowsPerPage}&status=open&type=new&search=${searchTerm}`
      );
      const { data } = response.data;
      setRow(data.records);
      //   console.log(data.summary.status.open);

      setOpenCount(data.summary.status.open);
      setClosedCount(data.summary.status.closed);
      setTotalCount(data.pagination.totalRecords);
    } catch (error) {
      console.error("Error fetching data", error);
      setRow([]);
      setOpenCount(0);
      setClosedCount(0);
      setTotalCount(0);
    }
  };

  useEffect(() => {
    fetchAuditList();
  }, [page, rowsPerPage, searchTerm]); // Add searchTerm as a dependency

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0); // Reset to the first page when searching
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const IconCell = ({ row }) => (
    <>
      <IconButton
        style={{
          border: "1px solid",
          borderRadius: "4px",
          padding: "2px",
          width: "24px",
          height: "24px",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: '#fff'
        }}
        color="primary"
        onClick={() => handleCallIconClick(row)}
      >
        <CallIcon fontSize="small" color="primary" />
      </IconButton>
    </>
  );

  const handleCallIconClick = (row) => {
    navigate("/dashboard", {
      state: {
        mobNo: row.Mobile,
      },
    });
  };

  return (
    <>
      <Paper>
        {/* Search Field */}
        <TextField
          label="Search"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={handleSearchChange}
          sx={{ marginBottom: 2, float: "right", margin: 1 }}
        />

        <TableContainer
          sx={{
            boxShadow: 2,
            borderRadius: "8px",
            margin: "16px 0",
          }}
        >
          <Table
            sx={{ minWidth: 650, height: "100%", tableLayout: "fixed" }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                  SNo
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 1,
                  }}
                >
                  Zone Name
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 1,
                  }}
                >
                  Farmer Name
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 0,
                  }}
                >
                  Branch Name
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 0,
                  }}
                >
                  Mobile Number
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 180,
                    padding: 0,
                  }}
                >
                  Previous Poultry Experience
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 180,
                    padding: 0,
                  }}
                >
                  Previous Company Name
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 0,
                  }}
                >
                  Shed Type
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 0,
                  }}
                >
                  Total Mortality
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 0,
                  }}
                >
                  First Week Mortality
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 0,
                  }}
                >
                  Average Lift Weight
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 0,
                  }}
                >
                  Average Body Weight
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 0,
                  }}
                >
                  Follow-up Date
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 0,
                  }}
                >
                  Remarks
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    width: 150,
                    padding: 0,
                  }}
                >
                  Last Modified On
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: 80,
                    padding: 0,
                    position: "sticky", // Make the cell sticky
                    right: 80, // Align it next to the Action column
                    backgroundColor: "#EEF0F4", // Set background color for visibility
                    zIndex: 10, // Higher z-index to stay above other cells
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: 80,
                    padding: 0,
                    position: "sticky", // Make the cell sticky
                    right: 0, // Align it next to the Action column
                    backgroundColor: "#EEF0F4", // Set background color for visibility
                    zIndex: 10, // Higher z-index to stay above other cells
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(row) && row?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={16}>No Data Available Yet.</TableCell>
                </TableRow>
              ) : ( Array.isArray(row) && 
                row.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center" ssx={{ width: 50, padding: 0 }}>
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: 150,
                        padding: 0,
                      }}
                    >
                      {row.Zone_Name || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: 150,
                        padding: 0,
                      }}
                    >
                      {row.farmer_name || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: 150,
                        padding: 0,
                      }}
                    >
                      {row.branch_Name || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: 150,
                        padding: 0,
                      }}
                    >
                      {row.Mobile || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: 180,
                        padding: 0,
                      }}
                    >
                      {row.previousPoultryExperience || "-"}
                    </TableCell>
                    <TableCell align="center" sx={{ width: 180, padding: 0 }}>
                      {row.previousCompanyName || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: 150,
                        padding: 0,
                      }}
                    >
                      {row.Shed_Type || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: 150,
                        padding: 0,
                      }}
                    >
                      {row.Total_Mortality || "-"}
                    </TableCell>
                    <TableCell align="center" sx={{ width: 150, padding: 0 }}>
                      {row.first_Week_M || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: 150,
                        padding: 0,
                      }}
                    >
                      {row.Avg_Lift_Wt || "-"}
                    </TableCell>
                    <TableCell align="center" sx={{ width: 150, padding: 0 }}>
                      {row.ABWT || "-"}
                    </TableCell>

                    <TableCell align="center" sx={{ width: 150, padding: 0 }}>
                      {row.follow_up_date === null
                        ? "-"
                        : moment(row.follow_up_date).format("DD-MM-YYYY")}
                    </TableCell>

                    <TableCell align="center" sx={{ width: 150, padding: 0 }}>
                      <LongTextComponent
                        text={row.remarks === null ? "-" : row.remarks}
                        maxLength={20}
                      />
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        width: 150,
                        padding: 0,
                      }}
                    >
                      {row.updatedAt === null
                        ? "-"
                        : moment(row.updatedAt).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: 80,
                        padding: 0,
                        position: "sticky", // Make the cell sticky
                        right: 80, // Align it next to the Action column
                        backgroundColor: "#EEF0F4", // Set background color for visibility
                        zIndex: 10, // Higher z-index to stay above other cells
                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      }}
                    >
                      {row.status === "-" ? (
                        "-"
                      ) : (
                        <Chip
                          label={row.status}
                          color={"error"}
                          size="small"
                          sx={{ textTransform: "capitalize" }}
                          // onClick={() => handleChipClick(row)}
                        />
                      )}
                    </TableCell>
                    {localStorage.getItem("empRole") === "100" && (
                      <TableCell
                        width={120}
                        sx={{
                          width: 80,
                          padding: 0,
                          position: "sticky", // Make the cell sticky
                          right: 0, // Align it next to the Action column
                          backgroundColor: "#EEF0F4", // Set background color for visibility
                          zIndex: 10, // Higher z-index to stay above other cells
                          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                          textAlign: 'center'
                        }}
                      >
                        <IconCell row={row} />
                      </TableCell>
                    )}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20, 50]}
          component="div"
          count={totalCount} // Adjust this to reflect the total count of records, if available
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
}

export default NewOpenLeadList;
